import React from "react";

export default function SocialProof() {
  return (
    <section className="lk-section lk-proof">
      <div className="lk-container">
        <p className="lk-proof-line">
          Built for busy business owners & new real estate agents ✦
          Stop losing leads after hours ✦ Turn missed calls into booked meetings
        </p>
      </div>
    </section>
  );
}
